import { jsx } from 'react/jsx-runtime';
import { withPlacement } from '../../hoc/withPlacement.mjs';
import { MEDIA_QUERY, RawHlsVideo } from '@moim/common';
import * as React from 'react';
import styled, { css } from 'styled-components';

var VideoContainer = styled.div.withConfig({
  displayName: "VideoContainer",
  componentId: "sc-l2x8jh-0"
})(["", ""], function (props) {
  if (props.ratio) {
    var rW = parseInt(props.ratio.split(":")[0], 10);
    var rH = parseInt(props.ratio.split(":")[1], 10);
    return css(["position:relative;width:100%;height:0;padding-top:", "%;> div{width:100%;position:absolute;inset:0;div[class^=\"Wrapper\"],div[class^=\"Media\"]{width:100%;height:100%;}@media ", "{div[class^=\"Media\"]{padding:0;}}}.video-js{height:100%;}video,.vjs-poster > img{object-fit:cover;}"], (100 * (rH / rW)).toFixed(2), MEDIA_QUERY.ONLY_MOBILE);
  }
  return css(["width:100%;height:fit-content;"]);
});
var VideoBlock = function VideoBlock(_ref) {
  var mimeType = _ref.mimeType,
    sourceUrl = _ref.sourceUrl,
    metaData = _ref.metaData,
    playerConfig = _ref.playerConfig;
  var _a, _b, _c, _d, _e;
  var width = (_a = metaData === null || metaData === void 0 ? void 0 : metaData.width) !== null && _a !== void 0 ? _a : 160;
  var height = (_b = metaData === null || metaData === void 0 ? void 0 : metaData.height) !== null && _b !== void 0 ? _b : 90;
  var handleVideoEnded = React.useCallback(function () {
    // NOTE: TBD
  }, []);
  return jsx(VideoContainer, {
    ratio: (_c = metaData === null || metaData === void 0 ? void 0 : metaData.ratio) !== null && _c !== void 0 ? _c : "".concat((_d = metaData === null || metaData === void 0 ? void 0 : metaData.width) !== null && _d !== void 0 ? _d : 16, ":").concat((_e = metaData === null || metaData === void 0 ? void 0 : metaData.height) !== null && _e !== void 0 ? _e : 9),
    children: jsx(RawHlsVideo, {
      sources: sourceUrl ? [{
        type: mimeType,
        src: sourceUrl
      }] : [],
      poster: metaData === null || metaData === void 0 ? void 0 : metaData.poster,
      width: width,
      height: height,
      staticRatio: "unset",
      loop: playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.loop,
      autoPlay: playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.autoPlay,
      controls: Boolean(playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.showControls),
      muted: (playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.autoPlay) ? true : playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.initialMute,
      disableMuteButton: playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.disableMuteButton,
      onEnded: (playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.loop) ? undefined : handleVideoEnded
    })
  });
};
var index = withPlacement(VideoBlock);

export { index as default };
